import { CALL_API } from '../middleware/ApiMiddleware';

export const GET_TRANSACTION_LIST_REQUEST = 'GET_TRANSACTION_LIST_REQUEST';
export const GET_TRANSACTION_LIST_FAILURE = 'GET_TRANSACTION_LIST_FAILURE';
export const GET_TRANSACTION_LIST_SUCCESS = 'GET_TRANSACTION_LIST_SUCCESS';

export const DOWNLOAD_TRANSACTION_LIST_CSV_REQUEST = 'DOWNLOAD_TRANSACTION_LIST_CSV_REQUEST';
export const DOWNLOAD_TRANSACTION_LIST_CSV_FAILURE = 'DOWNLOAD_TRANSACTION_LIST_CSV_FAILURE';
export const DOWNLOAD_TRANSACTION_LIST_CSV_SUCCESS = 'DOWNLOAD_TRANSACTION_LIST_CSV_SUCCESS';

const baseURL = 'xerce/cases/transactions';

export const getTransactionsList = (listFilters: ITransactionListFilters, hideLoadingWidget = false) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'post',
    body: listFilters,
    authenticated: true,
    types: [GET_TRANSACTION_LIST_REQUEST, GET_TRANSACTION_LIST_SUCCESS, GET_TRANSACTION_LIST_FAILURE],
    hideLoadingWidget,
  },
});

export const downloadTransactionListCSV = (downloadCSVRequestParams: ITransactionDownloadCSVRequest) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/download`,
    method: 'post',
    body: downloadCSVRequestParams,
    authenticated: true,
    types: [
      DOWNLOAD_TRANSACTION_LIST_CSV_REQUEST,
      DOWNLOAD_TRANSACTION_LIST_CSV_SUCCESS,
      DOWNLOAD_TRANSACTION_LIST_CSV_FAILURE,
    ],
  },
});
